import { findAssociationOptionByValue, useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { useStrategy } from '../../hooks/useStrategy';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerAssociatedCrmObjectHeadingSubtext = props => {
  const {
    logicGroup
  } = props;
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const {
    associationValue,
    associationOptions
  } =
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  useFlexibleAssociations(logicGroup);
  const associatedObjectName = getFilterFamilyObjectName(logicGroup.filterFamily);
  const selectedAssociationOption = findAssociationOptionByValue(associationOptions, associationValue);

  // if associations are empty use "Any" as association label
  if (associationOptions && associationOptions.length === 0) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ASSOCIATION_HEADER_ANY",
      options: {
        entityName: associatedObjectName
      }
    });
  }

  // primary association
  if (selectedAssociationOption && selectedAssociationOption.isPublicPrimary) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ASSOCIATION_HEADER_PRIMARY",
      options: {
        entityName: associatedObjectName
      }
    });
  }
  const isUnlabeled = !(selectedAssociationOption !== null && selectedAssociationOption !== void 0 && selectedAssociationOption.associatedObjectName) && !associationValue;

  // wildcard/unlabeled association
  if (selectedAssociationOption && selectedAssociationOption.isWildcard || isUnlabeled) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ASSOCIATION_HEADER_ANY",
      options: {
        entityName: associatedObjectName
      }
    });
  }

  // labeled association
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "newCustomerDataFilters.FilterFamilyGroupHeading.viewer.CRM_OBJECT_ASSOCIATION_HEADER_LABELED",
    options: {
      entityName: associatedObjectName,
      associatedObjectName: selectedAssociationOption ? selectedAssociationOption.associatedObjectName : associationValue
    }
  });
};
export default ViewerAssociatedCrmObjectHeadingSubtext;